/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 支付成功退款
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class PaymentOrderRefundParams {
  constructor(public amount?: number, public orderId?: string) {}
}

export default async function (
  params: PaymentOrderRefundParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/payment/orderRefund`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
